<template>
  <b-container fluid class="p-0">
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <div class="card">
          <div class="card-body pt-0">
            <div id="form-wizard1" class="mt-0">
              <b-tabs
                v-model="activeTabIndex"
                content-class="mt-4"
                @input="handleTabChange"
                nav-class="p-0 row list-inline custom-top-wizard-nav"
              >
                <b-tab v-if="!isAdminOrCounselor" lazy :disabled="false">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === 0, 'is-completed': true }">
                      <i class="fa fa-info-circle"></i>
                      <span v-html="instructions"></span>
                    </div>
                  </template>
                  <div class="p-4 bg-white rounded border my-3 text-start mx-auto" style="max-w-800px">
                    <p class="text-muted">
                      <span v-html="instructionDetails"></span>
                    </p>
                  </div>
                </b-tab>

                <b-tab lazy :disabled="false">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === getIndex('student'), 'is-completed': isTabCompleted('student') }">
                      <i class="fa fa-child"></i>
                      <span v-html="stuInfo"></span>
                    </div>
                  </template>
                  <PreCounsellingv1 ref="preCounsellingRefStudent" :propQuestionObj="studentQuestionObj" @emitUserProfileUpdated="handleLocalStoreUserSync" @emitProgressUpdated="(counts) => handleProgressUpdate('student', counts)"/>
                </b-tab>

                <b-tab lazy :disabled="!isPhotoTabUnlocked && !isAdminOrCounselor">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === getIndex('profilePicture'), 'is-completed': isTabCompleted('profilePicture'), 'disabled-nav': !isPhotoTabUnlocked && !isAdminOrCounselor }">
                      <i class="fa-solid fa-camera"></i>
                      <span v-html="profilePicture"></span>
                    </div>
                  </template>

                  <div class="profile-picture-workspace p-4 bg-white rounded border my-3 max-w-600 mx-auto">
                    <h4 class="text-dark fw-bold text-start" v-html="profilePicture1"></h4>
                    <span class="mb-4 text-dark fw-bold text-start">Only PNG or JPG formats allowed. Size &lt; 300kb</span>
                    <div class="mt-4 form-group row align-items-center justify-content-center">
                      <div class="col-auto">
                        <div class="profile-img-edit border position-relative" style="height: 160px; width: 160px; border-radius: 50%">
                          <img
                            v-if="vmProfilePic"
                            :src="vmProfilePic"
                            alt="profile-pic"
                            style="height: 100%; width: 100%; object-fit: contain; border-radius: 50%"
                          />
                          <i v-else class="fas fa-user d-flex justify-content-center align-items-center rounded-circle" style="font-size: 5rem; height: 100%; color: #c1c1c1; margin: auto;"></i>
                          <label class="p-image">
                            <i class="ri-pencil-line upload-button" style="cursor: pointer !important"></i>
                            <input
                              class="file-upload"
                              type="file"
                              accept="image/png,image/jpeg,image/jpg,image/webp"
                              style="display: block; position: absolute; opacity: 0; left: 0; top: 0; pointer-events: none"
                              @change="handleProfilePicChange($event)"
                            />
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4 text-center">
                      <button
                        type="button"
                        class="btn btn-primary border-0 px-4 me-2"
                        :disabled="cvProfilePicLoading || !hasNewProfilePicSelected"
                        @click="uploadProfilePic()"
                      >
                        <span v-if="cvProfilePicLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        {{savepropic}}
                      </button>
                    </div>
                  </div>
                </b-tab>

                <b-tab lazy :disabled="!isTabCompleted('profilePicture') && !isAdminOrCounselor">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === getIndex('parent1'), 'is-completed': isTabCompleted('parent1'), 'disabled-nav': !isTabCompleted('profilePicture') && !isAdminOrCounselor }">
                      <i class="fa fa-person"></i><span v-html="parent1"></span>
                    </div>
                  </template>
                  <PreCounsellingv1 ref="preCounsellingRefParent1" :propQuestionObj="parent1QuestionObj" @emitProgressUpdated="(counts) => handleProgressUpdate('parent1', counts)" @emitSingleParentToggle="handleSingleParentToggle"/>
                </b-tab>

                <!-- Parent 2 Tab (Conditionally Rendered) -->
                <b-tab v-if="!isSingleParent" lazy :disabled="!isParent2TabUnlocked && !isAdminOrCounselor">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === getIndex('parent2'), 'is-completed': isTabCompleted('parent2'), 'disabled-nav': !isParent2TabUnlocked && !isAdminOrCounselor }">
                      <i class="fa fa-person"></i><span v-html="parent2"></span>
                    </div>
                  </template>
                  <PreCounsellingv1 ref="preCounsellingRefParent2" :propQuestionObj="parent2QuestionObj" @emitProgressUpdated="(counts) => handleProgressUpdate('parent2', counts)"/>
                </b-tab>

                <b-tab v-if="isAdminOrCounselor" lazy :disabled="false">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === getIndex('general'), 'is-completed': isTabCompleted('general') }">
                      <i class="fa-solid fa-question"></i>
                      <span v-html="questuionAir"></span>
                    </div>
                  </template>
                  <PreCounsellingv1 ref="preCounsellingRefGeneral" :propQuestionObj="generalQuestionObj" @emitProgressUpdated="(counts) => handleProgressUpdate('general', counts)"/>
                </b-tab>

                <b-tab v-if="!isAdminOrCounselor" lazy :disabled="!isTcTabUnlocked && !isAdminOrCounselor" class="text-left">
                  <template #title>
                    <div class="wizard-nav-item" :class="{ 'active': activeTabIndex === tcTabIndex, 'is-completed': isTabCompleted('tnc'), 'disabled-nav': !isTabCompleted('parent2') && !isAdminOrCounselor }">
                      <i class="fa-solid fa-check"></i>
                      <span v-html="tnc"></span>
                    </div>
                  </template>
                  <GideContract :propOpenedInModal="false" :propGideContractObj="gideContractObj" :propContractId="gpBlogContractId" @emitContractTnCAccept="contractTnCAcceptHandler" @emitcloseGIDECounselingContractModal="closeGIDECounselingContractModal"/>
                </b-tab>
              </b-tabs>

              <div class="col-12 mt-4 pt-3 border-top d-flow-root">
                <div class="pull-right">
                  <button
                    type="button"
                    class="btn btn-dark float-end me-3 mr-2"
                    :disabled="activeTabIndex === 0"
                    @click="navigateStep(-1)"
                  >
                    Previous
                  </button>
                  <button
                    v-if="activeTabIndex < tcTabIndex"
                    type="button"
                    class="btn btn-primary float-end"
                    :disabled="!isCurrentTabAllowedToProceed"
                    @click="navigateStep(1)"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CropImage
      :prop-crop-image-dialog-open="propCropImageDialogOpen"
      :propCropModalSize="'md'"
      :prop-stencil-size="{ width: 150, height: 150 }"
      :propSrc="fileSrc"
      @emitCroppedImg="onProfilePicCroppedPreview"
      @emitCroppedImgFile="onProfilePicCroppedFileReady"
    />
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import GideContract from "./GideContract.vue"
import PreCounsellingv1 from "../Quiz/PreCounsellingv1.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import { Images } from "../../../FackApi/api/image.js"
import CropImage from "../../../components/cropImage.vue"

export default {
  name: "PAQ",
  components: {
    GideContract,
    PreCounsellingv1,
    CropImage
  },
  props: {
    propQuestionObj: {
      type: Object,
      default: null
    },
    propContractId: {
      type: String,
      default: null
    },
    propParentModuleObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      gide_user_id: null,
      activeRef: "preCounsellingRefStudent",
      activeTabIndex: 0,
      gideContractObj: {},
      tabProgress: {
        student: { attempted: 0, total: 0 },
        parent1: { attempted: 0, total: 0 },
        parent2: { attempted: 0, total: 0 },
        profilePicture: { attempted: 0, total: 0 },
        general: { attempted: 0, total: 0 }
      },
      vmProfilePic: "",
      fileSrc: "",
      tnc_flag: 0,
      hasNewProfilePicSelected: false,
      cvProfilePicLoading: false,
      propCropImageDialogOpen: false,
      gpBlogContractId: null,
      vmUserProPicImage: {
        module_id: "",
        module_name: "USER",
        image: [],
        image_type: {}
      },
      instructions: "General<br>Instructions",
      instructionDetails: `<h3>Important Instructions</h3><br>
        <p>Welcome to our student onboarding process. To ensure a smooth transition and personalized support for your child, please note that this form must be completed in full by a parent or legal guardian. The application is structured in sequential stages to ensure all necessary information is captured accurately; you will be required to finish each section completely before you are able to proceed to the next.</p>
        <p>Please follow these steps to finalize your onboarding:</p>
        <p><strong>Student Profile:</strong> Provide the student’s core academic details, including their full name, age, date of birth, current class, and the academic board they are affiliated with.</p>
        <p><strong>Parental Information:</strong> Enter comprehensive details for both parents, including your professional job profiles, your specific expectations for this academic journey, and a record of countries where you have previously resided.</p>
        <p><strong>Global Aspirations:</strong> Indicate the countries or regions where you expect the student to pursue their future education.</p>
        <p><strong>Enrollment Contract:</strong> Review the formal enrollment contract carefully. This document is mandatory and requires your digital signature to proceed.</p>
        <p><strong>Final Submission:</strong> Please be aware that all fields are strictly mandatory. The form will remain open until every section is completed and the final contract is signed and submitted; you will not be able to close or exit the process until all requirements are met.</p>`,
      parent1: "Parent 1<br>Information",
      parent2: "Parent 2<br>Information",
      Counselor: "Counselor",
      questuionAir: "Counselor<br>Questionnaire",
      profilePicture: "Profile<br>Picture",
      profilePicture1: "Profile Picture",
      stuInfo: "Student<br>Information",
      savepropic: "Save Profile Picture",
      tnc: `Enrollment<br>Contract`,
      isSingleParent: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    isAdminOrCounselor () {
      return this.userData.user_role === "USERROLE11111" || this.userData.user_role === "USERROLE11118"
    },
    photoTabIndex () {
      return this.getIndex("profilePicture")
    },
    tcTabIndex () {
      return this.getIndex("tnc")
    },
    isPhotoTabUnlocked () {
      return this.isTabCompleted("student")
    },
    // isTcTabUnlocked () {
    //   return this.isAdminOrCounselor ? this.isTabCompleted("general") : this.isTabCompleted("parent2")
    // },
    isTcTabUnlocked () {
      if (this.isAdminOrCounselor) return this.isTabCompleted("general")
      return this.isSingleParent ? this.isTabCompleted("parent1") : this.isTabCompleted("parent2")
    },
    studentQuestionObj () {
      return { ...this.propQuestionObj, qbk_category: "student", "tnc_flag": this.tnc_flag }
    },
    parent1QuestionObj () {
      return { ...this.propQuestionObj, qbk_category: "parent1", "tnc_flag": this.tnc_flag }
    },
    parent2QuestionObj () {
      return { ...this.propQuestionObj, qbk_category: "parent2", "tnc_flag": this.tnc_flag }
    },
    generalQuestionObj () {
      return { ...this.propQuestionObj, qbk_category: "counselor", "tnc_flag": this.tnc_flag }
    },
    isCurrentTabAllowedToProceed () {
      if (this.isAdminOrCounselor) {
        return true
      }

      const currentCategory = this.getCategoryKeyByIndex(this.activeTabIndex)
      if (currentCategory === "info" || !currentCategory) return true
      return this.isTabCompleted(currentCategory)
    },
    parent2TabIndex () {
      return this.getIndex("parent2")
    },
    isParent2TabUnlocked () {
      return !this.isSingleParent && this.isTabCompleted("parent1")
    }
  },
  async mounted () {
    socialvue.index()

    if (this.propContractId) {
      this.gpBlogContractId = this.propContractId
    }

    if (this.propQuestionObj) {
      this.gide_user_id = this.propQuestionObj?.user_id ? this.propQuestionObj.user_id : this.userData.user_id
    }
    else if (this.$route.params.gide_user_id) {
      this.gide_user_id = this.$route.params.gide_user_id ? this.$route.params.gide_user_id : this.userData.user_id
    }
    else {
      this.gide_user_id = this.userData.user_id
    }

    if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") &&
      this.gide_user_id != this.userData.user_id
    ) {
      // the user is a not an Admin or Counselor
      // the user is a student is trying to open another users counseling profile
      this.$router.push("/spcm_counseling_product")
      return
    }

    if (this.propParentModuleObj) {
      if (this.propParentModuleObj?.parent_module_name == "SPCM") {
        this.tnc_flag = this.propParentModuleObj?.spcm_tnc
      }
      else if (this.propParentModuleObj?.parent_module_name == "TPREP") {
        this.tnc_flag = this.propParentModuleObj?.tprep_tnc
      }
    }

    if (this.isAdminOrCounselor) {
      this.activeTabIndex = 0
    }

    this.imageGetProfileImages()

    this.gideContractObj = {
      ...this.propQuestionObj,
      blog_id: this.gpBlogContractId,
      user_id: this.gide_user_id,
      tnc_flag: this.tnc_flag
    }

    this.syncCategoryAndLoad(this.activeTabIndex)
  },
  methods: {
    /**
     * index arrays based on role profiles
     */
    getIndex (tabKey) {
      if (this.isAdminOrCounselor) {
        const adminMap = { student: 0, profilePicture: 1, parent1: 2, parent2: 3, general: 4, tnc: 5 }
        return adminMap[tabKey]
      }
      else {
        const studentMap = { info: 0, student: 1, profilePicture: 2, parent1: 3, parent2: 4, tnc: 5 }
        return studentMap[tabKey]
      }
    },
    /**
     * keys from active indices
     */
    getCategoryKeyByIndex (index) {
      if (this.isAdminOrCounselor) {
        const adminReverseMap = ["student", "profilePicture", "parent1", "parent2", "general", "tnc"]
        return adminReverseMap[index]
      }
      else {
        const studentReverseMap = ["info", "student", "profilePicture", "parent1", "parent2", "tnc"]
        return studentReverseMap[index]
      }
    },
    /**
     * image Get Profile Images
     */
    async imageGetProfileImages () {
      try {
        let imageProfileResp = await Images.imageListProfileImages(this, this.gide_user_id, this.gide_user_id)
        if (imageProfileResp?.resp_status) {
          this.vmProfilePic = imageProfileResp.resp_data.profile_pic
            ? imageProfileResp.resp_data.profile_pic.image_thumbnail
            : ""
        }
      }
      catch (err) {
        console.error("imageGetProfileImages error:", err.message)
      }
    },
    /**
     * handleTabChange
     */
    handleTabChange (index) {
      this.syncCategoryAndLoad(index)
    },
    /**
     * handleProgressUpdate
     */
    handleProgressUpdate (category, counts) {
      console.error("XXXX INFO handleProgressUpdate called with category:", category, "and counts:", counts)
      try {
        this.$set(this.tabProgress, category, {
          attempted: Number(counts.total_answers_count) || 0,
          total: Number(counts.total_questions_count) || 0
        })
        this.gide_user_id = this.gide_user_id

        this.tabProgress = Object.assign({}, this.tabProgress)
      }
      catch (err) {
        console.error("Exception occurred at handleProgressUpdate():", err.message)
      }
    },
    /**
     * isTabCompleted
     */
    isTabCompleted (category) {
      try {
        if (this.tnc_flag == 1) {
          return true
        }

        if (category == "profilePicture" && this.vmProfilePic) {
          return true
        }

        const data = this.tabProgress[category]
        if (!data || !data.total || data.total === 0) return false
        return data.attempted >= data.total
      }
      catch (err) {
        console.error("Exception occurred at isTabCompleted():", err.message)
        return false
      }
    },
    /**
     * handleSingleParentToggle
     */
    handleSingleParentToggle (status) {
      this.isSingleParent = status
      if (status) {
        // Bypass parent 2 validation checks by marking its progress complete
        this.tabProgress.parent2 = { attempted: 1, total: 1 }
      }
      else {
        this.tabProgress.parent2 = { attempted: 0, total: 0 }
      }
    },
    /**
     * navigateStep
     */
    navigateStep (direction) {
      let nextIndex = this.activeTabIndex + direction

      if (this.isSingleParent) {
        const parent2Idx = this.parent2TabIndex
        if (direction > 0 && this.activeTabIndex < parent2Idx && nextIndex === parent2Idx) {
          nextIndex = parent2Idx + 1
        }
        else if (direction < 0 && this.activeTabIndex > parent2Idx && nextIndex === parent2Idx) {
          nextIndex = parent2Idx - 1
        }
      }

      if (nextIndex >= 0 && nextIndex <= this.tcTabIndex) {
        this.activeTabIndex = nextIndex
        this.syncCategoryAndLoad(nextIndex)
      }
    },
    /**
     * syncCategoryAndLoad
     */
    syncCategoryAndLoad (index) {
      try {
        let activeRef = null
        const currentCategory = this.getCategoryKeyByIndex(index)

        if (currentCategory === "student") activeRef = "preCounsellingRefStudent"
        else if (currentCategory === "parent1") activeRef = "preCounsellingRefParent1"
        else if (currentCategory === "parent2") activeRef = "preCounsellingRefParent2"
        else if (currentCategory === "general") activeRef = "preCounsellingRefGeneral"
        else if (currentCategory === "profilePicture") activeRef = "preCounsellingRefProfilePicture"

        this.$nextTick(() => {
          if (activeRef && this.$refs[activeRef]) {
            this.activeRef = activeRef
          }
        })
      }
      catch (err) {
        console.error("Exception occurred at syncCategoryAndLoad():", err.message)
      }
    },
    /**
     * handleLocalStoreUserSync
     */
    async handleLocalStoreUserSync (questionAnswerObj) {
      if (this.gide_user_id !== this.userData.user_id || !questionAnswerObj) {
        return
      }

      let updateStoreData = {}
      const qId = questionAnswerObj.qbk_id
      const ans = questionAnswerObj.answer

      if (qId === "QBKPAQ000001") {
        updateStoreData.user_name = ans
      }
      else if (qId === "QBKPAQ000003") {
        updateStoreData.user_mobile = ans
      }
      else if (qId === "QBKPAQ000005") {
        updateStoreData.user_address = ans
      }
      else if (qId === "QBKPAQ000007") {
        updateStoreData.user_city = ans
      }
      else if (qId === "QBKPAQ000010") {
        updateStoreData.user_country_name = ans
      }
      else if (qId === "QBKPAQ000011") {
        updateStoreData.student_class = ans
      }
      else if (qId === "QBKPAQ000012") {
        updateStoreData.student_school_name = ans
      }
      else if (qId === "QBKPAQ000013") {
        updateStoreData.student_board = ans
      }

      if (Object.keys(updateStoreData).length > 0) {
        this.$store.commit("User/setUserProfile", {
          ...this.userData,
          ...updateStoreData
        })

        this.$nextTick(() => {
          console.log("userData justafter submit:", JSON.parse(JSON.stringify(this.userData)))
        })
      }
    },
    /**
     * handleProfilePicChange
     */
    handleProfilePicChange (e) {
      const input = e.target
      if (input.files && input.files[0]) {
        const file = input.files[0]
        const allowedExtensions = ["image/png", "image/jpg", "image/jpeg", "image/webp"]
        const maxSizeBytes = 300 * 1024

        if (!allowedExtensions.includes(file.type)) {
          this.$bvToast.toast("Only jpeg, webp, and png files are supported.", { variant: "danger", title: "Error" })
          return false
        }

        if (file.size > maxSizeBytes) {
          this.$bvToast.toast("Image file size must be less than 300 KB.", { variant: "danger", title: "Error" })
          return false
        }

        this.vmUserProPicImage = {
          module_id: this.gide_user_id,
          module_name: "USER",
          image: [],
          image_type: {}
        }

        this.fileSrc = file
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * onProfilePicCroppedPreview
     */
    onProfilePicCroppedPreview (base64ImgString) {
      this.vmProfilePic = base64ImgString
    },

    /**
     * onProfilePicCroppedFileReady
     */
    onProfilePicCroppedFileReady (imgObj) {
      const img = imgObj.imgFile
      const orgImg = imgObj.orgImage

      this.vmUserProPicImage.module_id = this.gide_user_id
      this.vmUserProPicImage.image = [{
        "img": img,
        "name": orgImg.name
      }]
      this.vmUserProPicImage.image_type[orgImg.name] = 2

      // Enforce clean state reactivity override flag
      this.$set(this, "hasNewProfilePicSelected", true)
    },

    /**
     * uploadProfilePic
     */
    async uploadProfilePic () {
      if (!this.hasNewProfilePicSelected || this.vmUserProPicImage.image.length === 0) {
        return
      }
      try {
        this.cvProfilePicLoading = true
        const response = await Images.imageProfileUpdate(this, this.vmUserProPicImage)
        await ApiResponse.responseMessageDisplay(this, response)

        if (response && response.resp_status) {
          this.hasNewProfilePicSelected = false

          if (response.resp_data && response.resp_data.length > 0) {
            const profileImage = response.resp_data[0]

            if (this.gide_user_id === this.userData.user_id) {
              let userProfileData = JSON.parse(JSON.stringify(this.userData))
              if (!userProfileData.user_image) {
                userProfileData.user_image = {}
              }

              let imageObj = {
                image: profileImage.image,
                image_id: profileImage.image_id,
                image_medium: profileImage.image_medium,
                image_thumbnail: profileImage.image_thumbnail
              }

              userProfileData.user_image["profile_pic"] = imageObj
              userProfileData.image = profileImage.image_thumbnail || ""

              await this.$store.dispatch("User/setUserProfileAction", { ...userProfileData })
            }
            this.vmProfilePic = profileImage.image_thumbnail

            this.handleProgressUpdate("profilePicture", { total_answers_count: 1, total_questions_count: 1 })
          }
        }
      }
      catch (err) {
        console.error("Crash processing structural form data configurations:", err.message)
      }
      finally {
        this.cvProfilePicLoading = false
      }
    },
    /**
     * contract TnC Accept
     */
    async contractTnCAcceptHandler () {
      this.$emit("emitContractTnCAccept")
    },
    /**
     * Close the Modal Box
     */
    closeGIDECounselingContractModal () {
      this.propOpenedInModal = false
      this.$router.push("/spcm_counseling_product")
    }
  }
}
</script>

<style scoped>
::v-deep .custom-top-wizard-nav {
    border-bottom: none !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    margin-left: -6px !important;
    margin-right: -6px !important;
    padding: 0 0 10px 0 !important;
    -webkit-overflow-scrolling: touch;
}

::v-deep .custom-top-wizard-nav::-webkit-scrollbar {
    height: 6px;
}

::v-deep .custom-top-wizard-nav::-webkit-scrollbar-thumb {
    background-color: #cdd1dc;
    border-radius: 4px;
}

::v-deep .custom-top-wizard-nav .nav-item {
    list-style: none;
    padding: 6px !important;
    flex: 0 0 auto !important;
    max-width: none !important;
}

::v-deep .custom-top-wizard-nav .nav-item .nav-link.disabled {
    pointer-events: none !important;
    cursor: not-allowed !important;
}

::v-deep .custom-top-wizard-nav .nav-link {
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    width: 100%;
    display: block;
}

.wizard-nav-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 14px 16px;
    background-color: #e9f5ff;
    color: #e5252c;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.3s ease;
    text-align: left;
    width: 100%;
    min-width: 180px;
}

.wizard-nav-item i {
    font-size: 16px;
    background: #ffffff;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    width: 32px;
    height: 32px;
    flex-shrink: 0;
}

.wizard-nav-item.active {
    background-color: #e5252c !important;
    color: #ffffff !important;
}
.wizard-nav-item.active i {
    color: #e5252c !important;
}

.wizard-nav-item.is-completed {
    background-color: #2dcdb2 !important;
    color: #ffffff !important;
}
.wizard-nav-item.is-completed i {
    color: #2dcdb2 !important;
}

.wizard-nav-item.disabled-nav {
    background-color: #f4f5f7 !important;
    color: #a0a5b5 !important;
    opacity: 0.65;
    pointer-events: none;
}
.wizard-nav-item.disabled-nav i {
    color: #cdd1dc !important;
    background: #f8f9fa;
}

.d-flow-root {
    display: flow-root;
}
button:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

@media (min-width: 576px) {
    ::v-deep .custom-top-wizard-nav .nav-item {
        flex: 0 0 auto !important;
        max-width: none !important;
    }
}

@media (min-width: 992px) {
    ::v-deep .custom-top-wizard-nav .nav-item {
        flex: 0 0 auto !important;
        max-width: none !important;
        padding: 0 6px !important;
    }
    .wizard-nav-item {
        font-size: 16px;
        padding: 15px 20px;
    }
}
</style>
